import { useSelector } from "react-redux";
import { errorHandeling } from "../errorHandeling";
import apiUrl from "../libs/baseUrl";
import axios from "axios";
import { useState, useCallback } from "react";

function useDepartmentUsers() {
  const token = useSelector((state) => state.user.token);

  const [empsArr, setEmpsArr] = useState([]);
  const [loadingResult, setLoadingResult] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [error, setError] = useState(null);

  // ================= FIXED FETCH =================
  const fetchEmps = useCallback(
    async (page = 1, searchValue = "") => {
      let url;

      if (searchValue) {
        url = `${apiUrl}/users/department-users/all/${searchValue}?page=${page}`;
      } else {
        url = `${apiUrl}/users/department-users/all?page=${page}`;
      }

      try {
        setLoadingResult(true);

        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const data = response.data.data;

        setEmpsArr(data.data);
        setCurrentPage(data.current_page);
        setTotalPages(data.last_page);

        setError(data.data.length === 0 ? "*لايوجد بيانات لعرضها" : null);

      } catch (err) {
        setError(errorHandeling(err));
      } finally {
        setLoadingResult(false);
      }
    },
    [token]
  );

  // optional alias (IMPORTANT for your app stability)
  const refetch = () => fetchEmps(currentPage);

  return {
    fetchEmps,
    refetch, // 👈 مهم جداً (حل مشكلة refetch is not a function)
    empsArr,
    loadingResult,
    currentPage,
    totalPages,
    error,
  };
}

export default useDepartmentUsers;